import * as angular from 'angular';
import LibraryWorkflowsGridBridge from './LibraryWorkflowsGridBridge';

angular
  .module('flowingly.runner.library')
  .component('libraryWorkflowsGrid', LibraryWorkflowsGridBridge);
